import React from 'react';
import FetchCharts from 'utils/fetch/FetchCharts';
import useForegroundPolling from 'utils/hooks/use-foreground-polling';
import HelperDate, { dateFormat } from 'utils/helper-date';
import LoadingComponent from 'components/atoms/Loading';
import GraphContainer from 'components/atoms/GraphContainer';
import ThemedBlock from 'components/atoms/ThemedBlock';
import WebView from 'components/atoms/WebView';
import Text from 'theme/Text';
import Button from 'theme/Button';
import i18n from 'utils/i18n';
import { textStyles } from 'styles/text';

const RefreshingChart = ({ fetchMethod, dateRange, building, floor, room, team, employee, liveToday = false }) => {
	const variables = { date: dateRange, buildingGuid: building, floorGuid: floor, roomGuid: room, teamGuid: team, employeeGuid: employee };
	const { data: chart, error, loading, retry } = useForegroundPolling({
		requestKey: JSON.stringify([fetchMethod, variables, liveToday]),
		interval: 60000,
		request: ( callbacks ) => {
			const date = HelperDate.date().format(dateFormat.DATE);
			FetchCharts[fetchMethod]({ variables: { ...variables, date: liveToday ? [date, date] : dateRange }, ...callbacks });
		},
	});

	let content = <LoadingComponent />;
	if( error ) {
		content = (
			<ThemedBlock transparent mediumPadding>

				<Text style={ textStyles.textCenter }>{ i18n.t('management:generic.load_error') }</Text>
				<Button onPress={ retry }>

					{ i18n.t('management:generic.retry') }
				</Button>
			</ThemedBlock>
		);
	} else if( chart?.html ) {
		content = <WebView html={ chart.html } />;
	} else if( !loading ) {
		content = (
			<ThemedBlock transparent mediumPadding>

				<Text style={ textStyles.textCenter }>{ i18n.t('management:generic.no_results') }</Text>
			</ThemedBlock>
		);
	}

	return (
		<GraphContainer chart={ chart ?? {} } title={ chart?.name }>

			{ content }
		</GraphContainer>
	);
};

export default RefreshingChart;
